// @flow
import React from 'react';
import PropTypes from 'prop-types';

import { Card, Section, Text } from 'seek-style-guide/react';

import moment from '@seek/moment-timezone-sydney';
const timeZone = 'Australia/Sydney';

const getExpiredMessage = (expiryDate: DateString) => {
  const expiredOn = moment(expiryDate).tz(timeZone);
  const now = moment().tz(timeZone);

  const daysElapsed = now.diff(expiredOn, 'days');
  const numOfDays = 90 - daysElapsed + 1;

  return numOfDays > 0
    ? `You can view this job for another ${
        numOfDays === 1 ? 'day' : `${numOfDays} days`
      } unless the advertiser removes it sooner. Please keep a copy of any important information.`
    : '';
};

const ExpiredMessage = ({ expiryDate }: { expiryDate: DateString }) => (
  <Card>
    <Section>
      <Text small critical strong data-automation="job-detail-expired-info">
        This job is no longer advertised
      </Text>
      <Text small secondary data-automation="job-detail-expired-description">
        {getExpiredMessage(expiryDate)}
      </Text>
    </Section>
  </Card>
);

ExpiredMessage.propTypes = {
  children: PropTypes.string.isRequired
};

export default ExpiredMessage;
